import { setDoor,setWall1DoorPosition, setWall2DoorPosition, setWall3DoorPosition,setWall4DoorPosition, configuratorState, setWallConfigDoorStates} from "../../../state"
import {useSnapshot} from "valtio";
import { useEffect, useState } from "react";
import Button from "./Button";
const DoorPosition = (props) => {
    const {activeWall, wallConfigStatesmse,selectedDoor} = useSnapshot(configuratorState);
    const handelClick = (value) => {
      props.setSelected(value);
      setWallConfigDoorStates(activeWall,value);
      switch(activeWall){
        case "wall1":
            setWall1DoorPosition(value);
            break;
        case "wall2":
            setWall2DoorPosition(value);
            break;
        case "wall3":
            setWall3DoorPosition(value);
            break;
        case "wall4":
            setWall4DoorPosition(value);
            break;
      }
      setDoor(activeWall, value);
    }
    useEffect(()=>{
        props.setSelected(selectedDoor);
    },[selectedDoor])

    return(
        <Button id={props.value} image ={true} value={props.value} label = {props.value} primary = {false} large ={false} leftAlign={true} onClick={() => handelClick(props.value)}/>


        // <button onClick={()=>handelClick(props.value)} style={{width:170, height:99,backgroundColor:"#D5D5D5", marginBottom:13}} className={`${wallConfigStates[activeWall].door===props.value?"selected":""}`}>
        // </button>
    )
}
const DoorPositionDropdown = () => {
    const [selected,setSelected] = useState("none");


    return(
        <div className="horizontal-options-left">
            <DoorPosition setSelected = {setSelected} selected={selected} value={"left"}/>
            <DoorPosition setSelected = {setSelected} selected={selected} value={"center"}/>
            <DoorPosition setSelected = {setSelected} selected={selected} value={"right"}/>
            <DoorPosition setSelected = {setSelected} selected={selected} value={"none"}/>
        </div>
    )
}

export default DoorPositionDropdown